import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { DialogProvider } from './components/Dialog';
import { Toaster } from './components/Toaster';
import { I18nProvider } from './lib/i18n';
import { SessionProvider } from './lib/session';
import { applyStoredTheme } from './lib/theme';
import './styles/index.css';

// Before the first paint, so the page never flashes the wrong room.
applyStoredTheme();

const container = document.getElementById('root');
if (!container) throw new Error('Root element is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <I18nProvider>
          <SessionProvider>
            <Toaster>
              <DialogProvider>
                <App />
              </DialogProvider>
            </Toaster>
          </SessionProvider>
        </I18nProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
